import React from 'react'

export const FacebookIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className={`icon--social icon--social-facebook ${props.className || ''}`}
    viewBox='0 0 32 32'
  >
    <path d='M23.926,24.625' />
    <path
      d='M13.193,29.229V17.159H9.132v-4.702h4.062V8.988c0-4.025,2.458-6.217,6.047-6.217c1.721,0,3.198,0.128,3.628,0.186v4.206L20.38,7.165c-1.953,0-2.332,0.928-2.332,2.289v3.003h4.658L22.1,17.159h-4.052v12.069'
    />
    <path d='M4.627,24.625' />
  </svg>
)
